import React, { useState, useEffect } from 'react';

interface ScrollToTopButtonProps {
  showAfter?: number; // Number of pixels to scroll before showing the button
  parentRef?: React.RefObject<HTMLElement>; // Optional parent element to scroll within
}

const ScrollToTopButton = ({
  showAfter = 300,
  parentRef
}: ScrollToTopButtonProps) => {
  const scrollContainer = parentRef?.current || window;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = parentRef?.current?.scrollTop || window.pageYOffset || document.documentElement.scrollTop;
      setIsVisible(scrollTop > showAfter);
    };

    scrollContainer.addEventListener('scroll', handleScroll, true);
    return () => scrollContainer.removeEventListener('scroll', handleScroll);
  }, [showAfter, parentRef]);

  const scrollToTop = () => {
    scrollContainer.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className={isVisible ? "back-to-top" : "back-to-top hidden"}>
      <a href="#top" className="button-round w-inline-block"  onClick={scrollToTop}>
        <img src={`${process.env.PUBLIC_URL}/assets/images/icons/white-triangle-up.svg`} loading="lazy" width="42" alt="" />
      </a>
    </div>
  );
};

export default ScrollToTopButton;